const ConditionType = {
  MATCHER: "matcher",
  GROUP: "group",
  HISTORICAL: "historical"
};
const MatcherType = {
  EQUALS: "eq",
  NOT_EQUALS: "ne",
  EXISTS: "ex",
  NOT_EXISTS: "nx",
  GREATER_THAN: "gt",
  GREATER_THAN_OR_EQUAL_TO: "ge",
  LESS_THAN: "lt",
  LESS_THAN_OR_EQUAL_TO: "le",
  CONTAINS: "co",
  NOT_CONTAINS: "nc",
  STARTS_WITH: "sw",
  ENDS_WITH: "ew"
};
const LogicType = {
  AND: "and",
  OR: "or"
};
const SearchType = {
  ORDERED: "ordered",
  MOST_RECENT: "mostRecent"
};

function isObjectOrUndefined(value) {
  return typeof value === "object" || typeof value === "undefined";
}

function createEquals() {
  return {
    matches: (context, key, values = []) => {
      if (isObjectOrUndefined(context[key])) {
        return false;
      }
      const contextValue = String(context[key]).toLowerCase();
      for (let i = 0; i < values.length; i += 1) {
        if (!isObjectOrUndefined(values[i]) && contextValue === String(values[i]).toLowerCase()) {
          return true;
        }
      }
      return false;
    }
  };
}

function createNotEquals() {
  return {
    matches: (context, key, values = []) => {
      if (isObjectOrUndefined(context[key])) {
        return false;
      }
      const contextValue = String(context[key]).toLowerCase();
      for (let i = 0; i < values.length; i += 1) {
        if (!isObjectOrUndefined(values[i]) && contextValue === String(values[i]).toLowerCase()) {
          return false;
        }
      }
      return true;
    }
  };
}

function createExists() {
  return {
    matches: (context, key) => {
      return typeof context[key] !== "undefined" && context[key] !== null;
    }
  };
}

function createNotExists() {
  return {
    matches: (context, key) => {
      return typeof context[key] === "undefined" || context[key] === null;
    }
  };
}

function isNumber(value) {
  return typeof value === "number";
}

function createGreaterThan() {
  return {
    matches: (context, key, values = []) => {
      const needle = context[key];
      if (!isNumber(needle)) {
        return false;
      }
      for (let i = 0; i < values.length; i += 1) {
        if (isNumber(values[i]) && needle > values[i]) {
          return true;
        }
      }
      return false;
    }
  };
}

function createGreaterThanEquals() {
  return {
    matches: (context, key, values = []) => {
      const needle = context[key];
      if (!isNumber(needle)) {
        return false;
      }
      for (let i = 0; i < values.length; i += 1) {
        if (isNumber(values[i]) && needle >= values[i]) {
          return true;
        }
      }
      return false;
    }
  };
}

function createLessThan() {
  return {
    matches: (context, key, values = []) => {
      const needle = context[key];
      if (!isNumber(needle)) {
        return false;
      }
      for (let i = 0; i < values.length; i += 1) {
        if (isNumber(values[i]) && needle < values[i]) {
          return true;
        }
      }
      return false;
    }
  };
}

function createLessThanEquals() {
  return {
    matches: (context, key, values = []) => {
      const needle = context[key];
      if (!isNumber(needle)) {
        return false;
      }
      for (let i = 0; i < values.length; i += 1) {
        if (isNumber(values[i]) && needle <= values[i]) {
          return true;
        }
      }
      return false;
    }
  };
}

function createContains() {
  return {
    matches: (context, key, values = []) => {
      if (isObjectOrUndefined(context[key])) {
        return false;
      }
      const contextValue = String(context[key]).toLowerCase();
      for (let i = 0; i < values.length; i += 1) {
        if (!isObjectOrUndefined(values[i]) && contextValue.indexOf(String(values[i]).toLowerCase()) !== -1) {
          return true;
        }
      }
      return false;
    }
  };
}

function createNotContains() {
  return {
    matches: (context, key, values = []) => {
      if (isObjectOrUndefined(context[key])) {
        return false;
      }
      const contextValue = String(context[key]).toLowerCase();
      for (let i = 0; i < values.length; i += 1) {
        if (!isObjectOrUndefined(values[i]) && contextValue.indexOf(String(values[i]).toLowerCase()) !== -1) {
          return false;
        }
      }
      return true;
    }
  };
}

function createStartsWith() {
  return {
    matches: (context, key, values = []) => {
      if (isObjectOrUndefined(context[key])) {
        return false;
      }
      const contextValue = String(context[key]).toLowerCase();
      for (let i = 0; i < values.length; i += 1) {
        if (!isObjectOrUndefined(values[i]) && contextValue.startsWith(String(values[i]).toLowerCase())) {
          return true;
        }
      }
      return false;
    }
  };
}

function createEndsWith() {
  return {
    matches: (context, key, values = []) => {
      if (isObjectOrUndefined(context[key])) {
        return false;
      }
      const contextValue = String(context[key]).toLowerCase();
      for (let i = 0; i < values.length; i += 1) {
        if (!isObjectOrUndefined(values[i]) && contextValue.endsWith(values[i].toLowerCase())) {
          return true;
        }
      }
      return false;
    }
  };
}

const MATCHERS = {
  [MatcherType.EQUALS]: createEquals(),
  [MatcherType.NOT_EQUALS]: createNotEquals(),
  [MatcherType.EXISTS]: createExists(),
  [MatcherType.NOT_EXISTS]: createNotExists(),
  [MatcherType.GREATER_THAN]: createGreaterThan(),
  [MatcherType.GREATER_THAN_OR_EQUAL_TO]: createGreaterThanEquals(),
  [MatcherType.LESS_THAN]: createLessThan(),
  [MatcherType.LESS_THAN_OR_EQUAL_TO]: createLessThanEquals(),
  [MatcherType.CONTAINS]: createContains(),
  [MatcherType.NOT_CONTAINS]: createNotContains(),
  [MatcherType.STARTS_WITH]: createStartsWith(),
  [MatcherType.ENDS_WITH]: createEndsWith()
};
function getMatcher(key) {
  return MATCHERS[key];
}

function isUndefined(value) {
  return typeof value === "undefined";
}

const IAM_ID = "iam.id";
const EVENT_ID = "eventId";
const ID = "id";
const IAM_EVENT_TYPE = "iam.eventType";
const EVENT_TYPE = "eventType";
const TYPE = "type";
const VALID_EVENT_TYPES = [IAM_EVENT_TYPE, EVENT_TYPE, TYPE];
const VALID_EVENT_IDS = [IAM_ID, ID];
const checkForHistoricalMatcher = (eventCount, matcherKey, value) => {
  switch (matcherKey) {
    case MatcherType.GREATER_THAN:
      return eventCount > value;
    case MatcherType.GREATER_THAN_OR_EQUAL_TO:
      return eventCount >= value;
    case MatcherType.LESS_THAN:
      return eventCount < value;
    case MatcherType.LESS_THAN_OR_EQUAL_TO:
      return eventCount <= value;
    case MatcherType.EQUALS:
      return eventCount === value;
    case MatcherType.NOT_EQUALS:
      return eventCount !== value;
    default:
      return false;
  }
};
const detectKeyName = (context, properties) => {
  for (let i = 0; i < properties.length; i += 1) {
    if (!isUndefined(context[properties[i]])) {
      return properties[i];
    }
  }
  throw new Error("The event does not match the expected schema.");
};
const normalizeEvent = originalEvent => {
  const event = structuredClone(originalEvent);
  [[detectKeyName(event, VALID_EVENT_TYPES), EVENT_TYPE], [detectKeyName(event, VALID_EVENT_IDS), EVENT_ID]].forEach(([keyName, normalizedKeyName]) => {
    if (keyName === normalizedKeyName) {
      return;
    }
    event[normalizedKeyName] = event[keyName];
    delete event[keyName];
  });
  return event;
};
function queryAndCountAnyEvent(events, context, options, from = 0, to = Infinity) {
  return events.reduce((countTotal, event) => {
    try {
      const eventHash = options.generateEventHash(normalizeEvent(event));
      const contextEvent = context.events[eventHash];
      if (!contextEvent) {
        return countTotal;
      }
      const {
        timestamps = []
      } = contextEvent;
      return countTotal + timestamps.filter(t => t >= from && t <= to).length;
    } catch {
      return countTotal;
    }
  }, 0);
}
function queryAndCountOrderedEvent(events, context, options, from = 0, to = Infinity) {
  try {
    let previousEventTimestamp = from;
    const sameSequence = events.every(event => {
      const eventHash = options.generateEventHash(normalizeEvent(event));
      const contextEvent = context.events[eventHash];
      if (!contextEvent) {
        return false;
      }
      const contextEventFirstTimestamp = contextEvent.timestamps[0];
      const isOrdered = contextEventFirstTimestamp >= previousEventTimestamp && contextEventFirstTimestamp <= to;
      previousEventTimestamp = contextEventFirstTimestamp;
      return isOrdered;
    });
    return Number(sameSequence);
  } catch {
    return 0;
  }
}
function queryAndCountMostRecentEvent(events, context, options, from = 0, to = Infinity) {
  try {
    return events.reduce((mostRecent, event, index) => {
      const eventHash = options.generateEventHash(normalizeEvent(event));
      const contextEvent = context.events[eventHash];
      if (!contextEvent) {
        return mostRecent;
      }
      const mostRecentTimestamp = contextEvent.timestamps.filter(t => t >= from && t <= to).pop();
      return mostRecentTimestamp && mostRecentTimestamp > mostRecent.timestamp ? {
        index,
        timestamp: mostRecentTimestamp
      } : mostRecent;
    }, {
      index: -1,
      timestamp: 0
    }).index;
  } catch {
    return -1;
  }
}

function evaluateAnd(context, conditions, options) {
  let result = true;
  for (let i = 0; i < conditions.length; i += 1) {
    result = result && conditions[i].evaluate(context, options);
  }
  return result;
}
function evaluateOr(context, conditions, options) {
  let result = false;
  for (let i = 0; i < conditions.length; i += 1) {
    result = result || conditions[i].evaluate(context, options);
    if (result) {
      return true;
    }
  }
  return false;
}
function createRules(version, rules, metadata) {
  return {
    version,
    rules,
    metadata
  };
}
function createRule(condition, consequences, key) {
  return {
    key,
    execute: (context, options) => {
      if (condition.evaluate(context, options)) {
        return consequences;
      }
      return [];
    },
    toString: () => {
      return `Rule{condition=${condition}, consequences=${consequences}}`;
    }
  };
}
function createCondition(type, definition) {
  return {
    evaluate: (context, options) => {
      return definition.evaluate(context, options);
    },
    toString() {
      return `Condition{type=${type}, definition=${definition}}`;
    }
  };
}
function createConsequence(id, type, detail) {
  return {
    id,
    type,
    detail
  };
}
function createGroupDefinition(logic, conditions) {
  return {
    evaluate: (context, options) => {
      if (LogicType.AND === logic) {
        return evaluateAnd(context, conditions, options);
      }
      if (LogicType.OR === logic) {
        return evaluateOr(context, conditions, options);
      }
      return false;
    }
  };
}
function createMatcherDefinition(key, matcherKey, values) {
  return {
    evaluate: context => {
      const matcher = getMatcher(matcherKey);
      if (!matcher) {
        return false;
      }
      return matcher.matches(context, key, values);
    }
  };
}
function createHistoricalDefinition(events, matcherKey, value, from, to, searchType) {
  return {
    evaluate: (context, options) => {
      let eventCount;
      if (SearchType.MOST_RECENT === searchType) {
        eventCount = queryAndCountMostRecentEvent(events, context, options, from, to);
      } else if (SearchType.ORDERED === searchType) {
        eventCount = queryAndCountOrderedEvent(events, context, options, from, to);
      } else {
        eventCount = queryAndCountAnyEvent(events, context, options, from, to);
      }
      return checkForHistoricalMatcher(eventCount, matcherKey, value);
    }
  };
}

function parseMatcherDefinition(definition) {
  const {
    key,
    matcher,
    values
  } = definition;
  return createMatcherDefinition(key, matcher, values);
}
function parseGroupDefinition(definition) {
  const {
    logic,
    conditions
  } = definition;
  return createGroupDefinition(logic, conditions.map(parseCondition));
}
function parseHistoricalDefinition(definition) {
  const {
    events,
    from,
    to,
    matcher,
    value,
    searchType
  } = definition;
  return createHistoricalDefinition(events, matcher, value, from, to, searchType);
}
function parseCondition(condition) {
  const {
    type,
    definition
  } = condition;
  if (ConditionType.MATCHER === type) {
    const matchers = parseMatcherDefinition(definition);
    return createCondition(type, matchers);
  }
  if (ConditionType.GROUP === type) {
    const definitions = parseGroupDefinition(definition);
    return createCondition(type, definitions);
  }
  if (ConditionType.HISTORICAL === type) {
    const definitions = parseHistoricalDefinition(definition);
    return createCondition(type, definitions);
  }
  throw new Error("Can not parse condition");
}
function parseConsequence(consequence) {
  const {
    id,
    type,
    detail
  } = consequence;
  return createConsequence(id, type, detail);
}
function parseRule(rule) {
  const {
    condition,
    consequences,
    key
  } = rule;
  const parsedCondition = parseCondition(condition);
  const parsedConsequences = consequences.map(parseConsequence);
  return createRule(parsedCondition, parsedConsequences, key);
}
function parseMetadata(metadata) {
  if (!metadata) {
    return undefined;
  }
  const result = {
    provider: metadata.provider,
    providerData: Object.assign({}, metadata.providerData)
  };
  return result;
}
function parseRules(ruleset) {
  const {
    version,
    rules,
    metadata
  } = ruleset;
  const parsedRules = rules.map(parseRule);
  const parsedMetadata = parseMetadata(metadata);
  return createRules(version, parsedRules, parsedMetadata);
}

const TARGET_PROVIDER = "TGT";
const DEFAULT_PROVIDER = "DEFAULT";

function createDefaultRulesExecutor(rules, options) {
  return {
    provider: DEFAULT_PROVIDER,
    execute: context => rules.map(rule => rule.execute(context, options)).filter(arr => arr.length > 0)
  };
}

function validateMetadata(metadata) {
  const {
    providerData
  } = metadata;
  if (!providerData) {
    throw new Error("Provider data is missing in metadata");
  }
  const {
    identityTemplate,
    buckets
  } = providerData;
  if (!identityTemplate) {
    throw new Error("Identity template is missing in provider data");
  }
  if (!buckets) {
    throw new Error("Buckets is missing in provider data");
  }
}

const NAMESPACE = "ECID";
function extractIdentity(context) {
  const {
    xdm
  } = context;
  if (!xdm) {
    throw new Error("XDM object is missing in the context");
  }
  const {
    identityMap
  } = xdm;
  if (!identityMap) {
    throw new Error("Identity map is missing in the XDM object");
  }
  const identities = identityMap[NAMESPACE];
  if (!identities) {
    throw new Error("ECID identity namespace is missing in the identity map");
  }
  if (!Array.isArray(identities) || identities.length === 0) {
    throw new Error("ECID identities array is empty or not an array");
  }
  const result = identities[0].id;
  if (!result) {
    throw new Error("ECID identity is missing in the identities array");
  }
  return result;
}

const KEY_PATTERN = "<key>";
const IDENTITY_PATTERN = "<identity>";
function createId(identity, key, metadata) {
  const {
    providerData
  } = metadata;
  const {
    identityTemplate
  } = providerData;
  return identityTemplate.replace(KEY_PATTERN, key).replace(IDENTITY_PATTERN, identity);
}

function isDefined(value) {
  return !isUndefined(value);
}

function memoize(func, keyResolverFunc = arr => arr[0]) {
  const memoizedValues = {};
  return function memoized(...funcArgs) {
    const key = keyResolverFunc(funcArgs);
    if (!isDefined(memoizedValues[key])) {
      memoizedValues[key] = func(...funcArgs);
    }
    return memoizedValues[key];
  };
}

function mul32(m, n) {
  const nlo = n & 0xffff;
  const nhi = n - nlo;
  return (nhi * m | 0) + (nlo * m | 0) | 0;
}
function hashUnencodedCharsRaw(stringValue, seed = 0) {
  let k1;
  const len = stringValue.length;
  const c1 = 0xcc9e2d51;
  const c2 = 0x1b873593;
  let h1 = seed;
  const roundedEnd = len & -2;
  for (let i = 0; i < roundedEnd; i += 2) {
    k1 = stringValue.charCodeAt(i) | stringValue.charCodeAt(i + 1) << 16;
    k1 = mul32(k1, c1);
    k1 = (k1 & 0x1ffff) << 15 | k1 >>> 17;
    k1 = mul32(k1, c2);
    h1 ^= k1;
    h1 = (h1 & 0x7ffff) << 13 | h1 >>> 19;
    h1 = h1 * 5 + 0xe6546b64 | 0;
  }
  if (len % 2 === 1) {
    k1 = stringValue.charCodeAt(roundedEnd);
    k1 = mul32(k1, c1);
    k1 = (k1 & 0x1ffff) << 15 | k1 >>> 17;
    k1 = mul32(k1, c2);
    h1 ^= k1;
  }
  h1 ^= len << 1;
  h1 ^= h1 >>> 16;
  h1 = mul32(h1, 0x85ebca6b);
  h1 ^= h1 >>> 13;
  h1 = mul32(h1, 0xc2b2ae35);
  h1 ^= h1 >>> 16;
  return h1;
}
const hashUnencodedChars = memoize(hashUnencodedCharsRaw, arr => arr.join("-"));

const MAX_PERCENTAGE = 100;
function createAllocation(id, buckets) {
  const signedNumericHashValue = hashUnencodedChars(id);
  const hashFixedBucket = Math.abs(signedNumericHashValue) % buckets;
  const allocationValue = hashFixedBucket / buckets * MAX_PERCENTAGE;
  return Math.round(allocationValue * MAX_PERCENTAGE) / MAX_PERCENTAGE;
}
const createAllocationMemoized = memoize(createAllocation);
function createContext(id, buckets, context) {
  const allocation = createAllocationMemoized(id, buckets);
  return {
    allocation,
    ...context
  };
}

function groupRules(rules) {
  const result = {};
  for (let i = 0; i < rules.length; i += 1) {
    const rule = rules[i];
    if (!rule.key) {
      continue;
    }
    if (!result[rule.key]) {
      result[rule.key] = [];
    }
    result[rule.key].push(rule);
  }
  return result;
}
function evaluateRules(context, rules) {
  return rules.map(rule => rule.execute(context)).filter(arr => arr.length > 0);
}
function createTargetRulesExecutor(rules, metadata) {
  validateMetadata(metadata);
  const rulesNoKey = rules.filter(rule => !rule.key);
  const rulesWithKeys = groupRules(rules);
  const {
    buckets
  } = metadata.providerData;
  return {
    provider: TARGET_PROVIDER,
    execute: context => {
      const identity = extractIdentity(context);
      const consequencesNoKey = evaluateRules(context, rulesNoKey);
      const rulesKeys = Object.keys(rulesWithKeys);
      const consequencesWithKeys = [];
      for (let i = 0; i < rulesKeys.length; i += 1) {
        const key = rulesKeys[i];
        const rulesForKey = rulesWithKeys[key];
        const id = createId(identity, key, metadata);
        const contextForKey = createContext(id, buckets, context);
        const consequences = evaluateRules(contextForKey, rulesForKey);
        consequencesWithKeys.push(...consequences);
      }
      return [...consequencesNoKey, ...consequencesWithKeys];
    }
  };
}

function createExecutor(rules, metadata, options) {
  const {
    provider
  } = metadata;
  if (provider === TARGET_PROVIDER) {
    return createTargetRulesExecutor(rules, metadata);
  }
  return createDefaultRulesExecutor(rules, options);
}

function RulesEngine(ruleset, options = {
  generateEventHash: () => {
    throw new Error("No hash function provided");
  }
}) {
  const {
    rules,
    metadata = {}
  } = parseRules(ruleset);
  return createExecutor(rules, metadata, options);
}

export { RulesEngine as default };
